// extracted by mini-css-extract-plugin
export default {"arrow":"ArrowIcon-index__arrow--IWYX8","inverted":"ArrowIcon-index__inverted--SMiVa","active":"ArrowIcon-index__active--cpEVR"};